import PQueue from "p-queue"

import { VoximplantSdk } from "modules/Call/sdk"

export class VoximplantLocalVideo {
    private static instance: VoximplantLocalVideo
    private readonly sdk = VoximplantSdk.getInstance()
    private readonly pQueue = new PQueue({ timeout: 10000, interval: 2000 })
    private enabled = false
    private enableInProcess = false

    public static getInstance() {
        if (!VoximplantLocalVideo.instance) {
            VoximplantLocalVideo.instance = new VoximplantLocalVideo()
        }
        return VoximplantLocalVideo.instance
    }

    public async enable(on: boolean) {
        if (this.enableInProcess) return on
        if (this.enabled !== on) {
            this.enabled = on
            this.enableInProcess = true
            const mediaRenderer = await this.pQueue.add(() => this.sdk.showLocalVideo(on))
            this.enabled = (mediaRenderer && mediaRenderer.enabled) || false
            this.enableInProcess = false
        }
        return on
    }
}
